import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "page_header" }
const _hoisted_2 = {
  key: 0,
  class: "formContainer"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "col-md-4" }
const _hoisted_6 = { class: "col-md-4" }
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "col-md-4" }
const _hoisted_9 = { class: "col-md-4" }
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "col-md-4" }
const _hoisted_14 = { class: "col-md-2" }
const _hoisted_15 = { class: "col-md-3" }
const _hoisted_16 = { class: "col-md-3" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "col-md-3" }
const _hoisted_19 = { class: "col-md-3" }
const _hoisted_20 = { class: "col-md-5" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "col-md-6" }
const _hoisted_26 = { class: "col-md-12" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_30 = { class: "row" }
const _hoisted_31 = { class: "col-md-3" }
const _hoisted_32 = { class: "col-md-3" }
const _hoisted_33 = { class: "col-md-3" }
const _hoisted_34 = { class: "col-md-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_36 = { class: "text-muted fs_14 mb-3" }
const _hoisted_37 = { class: "col-md-4" }
const _hoisted_38 = { class: "col-md-5" }
const _hoisted_39 = {
  key: 0,
  class: "col-md-3 mb-3 pt-4"
}
const _hoisted_40 = ["onClick", "disabled"]
const _hoisted_41 = {
  key: 0,
  class: "fs_12 text-muted ms-2"
}
const _hoisted_42 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_43 = {
  key: 1,
  class: "d-flex align-items-center justify-content-center mt-4 pt-4 mb-5"
}
const _hoisted_44 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_form_field = _resolveComponent("form-field")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_localized_text, {
        type: 'h1',
        localizedKey: "Company Profile",
        text: "Company Profile",
        class: "mb-0"
      })
    ]),
    (_ctx.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_localized_text, {
            type: "h5",
            localizedKey: "Supplier registry",
            text: "Supplier registry",
            class: "mb-3"
          }),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_form_field, {
                type: "email",
                modelValue: _ctx.providerEmail,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.providerEmail) = $event)),
                labelKey: "Email *",
                labelValue: "Email *",
                required: true,
                readonly: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.code,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.registry.code) = $event)),
                labelKey: "Supplier code *",
                labelValue: "Supplier code *",
                required: true,
                readonly: _ctx.isReadOnly || _ctx.codeAssigned
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.companyName,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.registry.companyName) = $event)),
                labelKey: "Company Legal Name *",
                labelValue: "Company Legal Name *",
                required: true,
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.status,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.registry.status) = $event)),
                labelKey: "Status *",
                labelValue: "Status *",
                required: true,
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.vatNumber,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.registry.vatNumber) = $event)),
                labelKey: "VAT number *",
                labelValue: "VAT number *",
                required: true,
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.fiscalCode,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.model.registry.fiscalCode) = $event)),
                labelKey: "Fiscal code",
                labelValue: "Fiscal code",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.address,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.registry.address) = $event)),
                labelKey: "Address *",
                labelValue: "Address *",
                required: true,
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.postalCode,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.registry.postalCode) = $event)),
                labelKey: "Postal code",
                labelValue: "Postal code",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.municipality,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.registry.municipality) = $event)),
                labelKey: "Municipality",
                labelValue: "Municipality",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.locality,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.model.registry.locality) = $event)),
                labelKey: "Locality *",
                labelValue: "Locality *",
                required: true,
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.province,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.registry.province) = $event)),
                labelKey: "Province *",
                labelValue: "Province *",
                required: true,
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.country,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.registry.country) = $event)),
                labelKey: "Country *",
                labelValue: "Country *",
                required: true,
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.language,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.registry.language) = $event)),
                labelKey: "Language *",
                labelValue: "Language *",
                required: true,
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.nationalPhonePrefix,
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.model.registry.nationalPhonePrefix) = $event)),
                labelKey: "National phone prefix",
                labelValue: "National phone prefix",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.localPhonePrefix,
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.registry.localPhonePrefix) = $event)),
                labelKey: "Local phone prefix",
                labelValue: "Local phone prefix",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.phone,
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.model.registry.phone) = $event)),
                labelKey: "Phone",
                labelValue: "Phone",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registry.typology,
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model.registry.typology) = $event)),
                labelKey: "Typology *",
                labelValue: "Typology *",
                required: true,
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ])
          ]),
          _hoisted_21,
          _createVNode(_component_localized_text, {
            type: "h5",
            localizedKey: "Additional company information",
            text: "Additional company information",
            class: "mb-3"
          }),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.registeredAddress,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.model.registeredAddress) = $event)),
                labelKey: "Registered Address",
                labelValue: "Registered Address",
                placeholderKey: "Registered Address",
                placeholderValue: "Registered Address",
                readonly: true
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.legalForm,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.model.legalForm) = $event)),
                labelKey: "Legal Form",
                labelValue: "Legal Form",
                placeholderKey: "Legal Form",
                placeholderValue: "Legal Form",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createVNode(_component_form_field, {
                type: "number",
                modelValue: _ctx.model.establishmentYear,
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.model.establishmentYear) = $event)),
                labelKey: "Establishment Year",
                labelValue: "Establishment Year",
                placeholderKey: "Year",
                placeholderValue: "Year",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.parentCompanyGroupStructure,
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.model.parentCompanyGroupStructure) = $event)),
                labelKey: "Parent Company / Group Structure",
                labelValue: "Parent Company / Group Structure",
                placeholderKey: "Parent Company / Group Structure",
                placeholderValue: "Parent Company / Group Structure",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.mainActivities,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.model.mainActivities) = $event)),
                labelKey: "Main Activities",
                labelValue: "Main Activities",
                placeholderKey: "Main Activities",
                placeholderValue: "Main Activities",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_form_field, {
                type: "select-string",
                modelValue: _ctx.model.valueChainPosition,
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.model.valueChainPosition) = $event)),
                labelKey: "Value Chain Position",
                labelValue: "Value Chain Position",
                placeholderKey: "Select position",
                placeholderValue: "Select position",
                list: _ctx.valueChainOptions,
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "list", "readonly"])
            ])
          ]),
          _hoisted_29,
          _createVNode(_component_localized_text, {
            type: "h5",
            localizedKey: "ESG Contact Person",
            text: "ESG Contact Person",
            class: "mb-3"
          }),
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.esgContactPerson.name,
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.model.esgContactPerson.name) = $event)),
                labelKey: "Name",
                labelValue: "Name",
                placeholderKey: "Name",
                placeholderValue: "Name",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.esgContactPerson.role,
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.model.esgContactPerson.role) = $event)),
                labelKey: "Role",
                labelValue: "Role",
                placeholderKey: "Role",
                placeholderValue: "Role",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_form_field, {
                type: "email",
                modelValue: _ctx.model.esgContactPerson.email,
                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.model.esgContactPerson.email) = $event)),
                labelKey: "Email",
                labelValue: "Email",
                placeholderKey: "Email",
                placeholderValue: "Email",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(_component_form_field, {
                type: "text",
                modelValue: _ctx.model.esgContactPerson.phone,
                "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.model.esgContactPerson.phone) = $event)),
                labelKey: "Phone",
                labelValue: "Phone",
                placeholderKey: "Phone",
                placeholderValue: "Phone",
                readonly: _ctx.isReadOnly
              }, null, 8, ["modelValue", "readonly"])
            ])
          ]),
          _hoisted_35,
          _createVNode(_component_localized_text, {
            type: "h5",
            localizedKey: "Production Sites",
            text: "Production Sites",
            class: "mb-3"
          }),
          _createElementVNode("p", _hoisted_36, [
            _createVNode(_component_localized_text, {
              localizedKey: "Add the production sites you own. The due diligence survey must be completed for each production site separately.",
              text: "Add the production sites you own. The due diligence survey must be completed for each production site separately."
            })
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.factories, (factory, fi) => {
            return (_openBlock(), _createElementBlock("div", {
              key: fi,
              class: "row mb-2"
            }, [
              _createElementVNode("div", _hoisted_37, [
                _createVNode(_component_form_field, {
                  type: "text",
                  modelValue: factory.name,
                  "onUpdate:modelValue": ($event: any) => ((factory.name) = $event),
                  labelKey: "Production Site Name *",
                  labelValue: "Production Site Name *",
                  placeholderKey: "Production Site Name",
                  placeholderValue: "Production Site Name",
                  required: true,
                  readonly: _ctx.isReadOnly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
              ]),
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_form_field, {
                  type: "text",
                  modelValue: factory.address,
                  "onUpdate:modelValue": ($event: any) => ((factory.address) = $event),
                  labelKey: "Production Site Address *",
                  labelValue: "Production Site Address *",
                  placeholderKey: "Production Site Address",
                  placeholderValue: "Production Site Address",
                  required: true,
                  readonly: _ctx.isReadOnly
                }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly"])
              ]),
              (!_ctx.isReadOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                    _createElementVNode("button", {
                      class: "btn btn-danger btn-sm mt-2",
                      onClick: ($event: any) => (_ctx.removeFactory(fi)),
                      disabled: _ctx.factoryHasSubmittedSurvey(factory)
                    }, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Remove",
                        text: "Remove"
                      })
                    ], 8, _hoisted_40),
                    (_ctx.factoryHasSubmittedSurvey(factory))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Survey submitted",
                            text: "Survey submitted"
                          })
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("button", {
                  class: "btn btn-secondary btn-sm",
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.addFactory()))
                }, [
                  _createTextVNode(" + "),
                  _createVNode(_component_localized_text, {
                    localizedKey: "Add Production Site",
                    text: "Add Production Site"
                  })
                ])
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isReadOnly)
            ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                _createElementVNode("button", {
                  class: "btn btn-tertiary",
                  disabled: _ctx.saveDisabled,
                  onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.save()))
                }, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Save Profile",
                    text: "Save Profile"
                  })
                ], 8, _hoisted_44)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}